/**
 *
 * @module sessionManagerConfiguration
 *
 */

import ServiceConfiguration from './serviceConfiguration';

/**
 *
 * @class SessionManagerConfiguration
 * @desc Provides configuration information necessary for managing session.
 *
 */
export default class SessionManagerConfiguration extends ServiceConfiguration {}



// WEBPACK FOOTER //
// ./src/services/configuration/sessionManagerConfiguration.js